export default __webpack_public_path__ + "static/media/36_mobile.d2d9cd7a.jpg";